import { apiCall, filterParams, apiFile } from '../helpers/axios';

class ItemService {

	static getOne(itemId, params) {
		return apiCall().get(`/items/${itemId}`, { params: params })
			.then(response => response.data)
	}

	static getItems(params, cancelToken) {
		return apiCall().get(`/items`, { params: params, cancelToken: cancelToken })
			.then(response => response.data)
	}

	static deleteOne(itemId) {
		return apiCall().delete(`/items/${itemId}`)
			.then(response => response.data)
	}

	static updateOne(itemId, data) {
		return apiCall().put(`/items/${itemId}`, data)
			.then(response => response.data)
	}

	static moveOne(itemId, data) {
		return apiCall().post(`/items/${itemId}/move`, data)
			.then(response => response.data)
	}

	static insertOne(item) {
		return apiCall().post(`/items`, item)
			.then(response => response.data)
	}

	static uploadMedia(itemId, data) {
		return apiCall().post(`/items/${itemId}/media`, data)
			.then(response => response.data)
	}

	static deleteMedia(itemId, mediaId) {
		return apiCall().delete(`/items/${itemId}/media/${mediaId}`)
			.then(response => response.data)
	}

	static getBid(itemId, bidId) {
		return apiCall().get(`/items/${itemId}/bid/${bidId}`)
			.then(response => response.data);
	}

	static createBid(itemId, data) {
		return apiCall().post(`/items/${itemId}/bid`, data)
			.then(response => response.data);
	}

	static updateBid(itemId, bidId, data) {
		return apiCall().put(`/items/${itemId}/bid/${bidId}`, data)
			.then(response => response.data);
	}

	static deleteBid(itemId, bidId) {
		return apiCall().delete(`/items/${itemId}/bid/${bidId}`);
	}

	static getPendingBid(itemId, pendingBidId) {
		return apiCall().get(`/items/${itemId}/pending_bids/${pendingBidId}`)
			.then(response => response.data);
	}

	static createPendingBid(itemId, data) {
		return apiCall().post(`/items/${itemId}/pending_bids`, data)
			.then(response => response.data);;
	}

	static updatePendingBid(itemId, pendingBidId, data) {
		return apiCall().put(`/items/${itemId}/pending_bids/${pendingBidId}`, data)
			.then(response => response.data);;
	}

	static deletePendingBid(itemId, pendingBidId) {
		return apiCall().delete(`/items/${itemId}/pending_bids/${pendingBidId}`)
			.then(response => response.data);
	}

	static getItemLabel(itemId, params) {
		return apiFile(`/items/${itemId}/label`, params);
	}

	static getNextAuctionOrderNumber(auctionId, categoryId) {
		return apiCall().get(`/auctions/${auctionId}/category/${categoryId}/next_auction_order_number`)
			.then(response => response.data);
	}

	static getNextAuctionItemNumber(auctionId, sellerId) {
		return apiCall().get(`/auctions/${auctionId}/seller/${sellerId}/next_item_number`)
			.then(response => response.data);
	}

	static setBuyerItemsPaymentStatus(auctionId, bidNumber, data) {
		return apiCall().put(`/auctions/${auctionId}/bid_number/${bidNumber}/items_payment`, data)
			.then(response => response.data);
	}

	static setSellerItemsPaymentStatus(auctionId, sellerId, data) {
		return apiCall().put(`/auctions/${auctionId}/seller/${sellerId}/items_payment`, data)
			.then(response => response.data);
	}

	static moveUnsoldItemsBySeller(auctionId, sellerId, newAuctionId) {
		return apiCall()
			.post(`/auctions/${auctionId}/seller/${sellerId}/move_unsold_items_to_auction`, {
				new_auction_id: newAuctionId
			})
			.then(response => response.data);
	}
}

export default ItemService


// WEBPACK FOOTER //
// ./src/services/item-service.js